import { styled as e, Box as i } from "@mui/material";
import { SkeletonTypography as o } from "../../temp-lib/components/share/generic/Skeleton.js";
import m from "../../temp-lib/components/share/next/Image.js";
import { DEFAULT_ALT as f } from "../../temp-lib/constants/layout.js";
import { jsxs as n, jsx as t } from "react/jsx-runtime";
const x = e(i)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 20px;
`, d = e(m)`
  aspect-ratio: 1;
  width: 34px;
`, g = e(i)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-end;
`, h = e(o)`
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
`, u = e(o)`
  color: #b1b3b3;
  font-size: 14px;
  font-weight: 300;
  line-height: 14px;
`, U = (r) => {
  const {
    amount: s,
    className: c,
    iconUrl: l,
    loading: a = !1,
    unit: p
  } = r;
  return /* @__PURE__ */ n(x, {
    className: c,
    children: [/* @__PURE__ */ t(d, {
      src: l,
      alt: f
    }), /* @__PURE__ */ n(g, {
      children: [/* @__PURE__ */ t(h, {
        loading: a,
        children: s
      }), /* @__PURE__ */ t(u, {
        children: p
      })]
    })]
  });
};
export {
  U as default
};
//# sourceMappingURL=Token.js.map
